import { io, Socket } from 'socket.io-client';
import config from "../config";
import { getUserFromCookie } from "../helpers/api/apiCore";

// Build a canonical origin and path for Socket.IO engine
const RAW_URL = config.SOCKET_URL || config.API_URL || "";
let ORIGIN = RAW_URL;
try {
    const u = new URL(RAW_URL);
    ORIGIN = u.origin; // ensures we target the default namespace '/'
} catch {
    // if RAW_URL is already an origin or empty, keep as-is
}
const ENGINE_PATH = '/socket.io';

let socket: Socket | null = null;

export function createSupplierSocket(token: string): Socket {
    return io(ORIGIN, {
        path: ENGINE_PATH,
        transports: ['websocket'],
        // Token in `auth` (handshake body) only. Previously also placed in
        // `query`, which leaks into URLs / ALB access logs / OTel http.*
        // span attributes. Server reads handshake.auth.token (with a
        // handshake.query.token fallback for the transition window).
        auth: { token },
        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 1000,
    });
}

export function initSocket(token?: string): Socket | null {
    if (socket) return socket;
    const user = token ? { access_token: token } : getUserFromCookie();
        if (!ORIGIN || !user?.access_token) return null;
    socket = createSupplierSocket(user.access_token);
    return socket;
}

export function getSocket(): Socket | null {
    return socket;
}

export function disconnectSocket(): void {
    if (socket) {
        socket.removeAllListeners();
        socket.disconnect();
        socket = null;
    }
}

// Backward compatibility: eagerly initialize if possible and export named `socket` ref
// This mirrors previous behavior so existing chat/vox flows keep working.
(() => {
    const user = getUserFromCookie();
        if (!socket && ORIGIN && user?.access_token) {
        socket = createSupplierSocket(user.access_token);
    }
})();

export { socket };
